export const functionCalls = [
    {
        "type": "function",
        "function": {
            "name": "thinkingProcess",
            "description": "explain your reasoning and decision process.",
            "parameters": {
                "type": "object",
                "properties": {
                    "text": {
                        "type": "string",
                        "description": "your thinking."
                    }
                }
            }
        }
    },

    {
        "type": "function",
        "function": {
            "name": "navigateToPage",
            "description": `navigate the router to the selected page.
                Use this mapping:
                - "home", "main" → "/home"
                - "scenes", "scene list" → "/editor/list"
                - "scene" → "/editor/scene/"
                - "resources", "resource list" → "/resources/list"
                - "paint", "paint list" → "/paint/list"
                - "catalog", "catalog list", "catalog editor" → "/catalog/list"
                - "scheduler", "scheduler editor" → "/scheduler/editor"
                - "events", "event list" → "/events/list"
                - "stations", "station list", "players", "player list" → "/stations"
                - "fasterq" → "/fasterq/list"
                - "statistics", "dashboard" → "/statistics"
                - "download" → "/download"
                - "products",  → "/shopping/products"
                - "cart", "shopping", "shopping list" → "/shopping/list"
                - "checkout", "shopping checkout" → "/shopping/checkout"
                - "account", "payment", "payment info", "orders", "security" → "/orders"
                - "settings" → "/user"
                - "help", "how", "what", "learn" → "/help"
            `,
            "parameters": {
                "type": "object",
                "properties": {
                    "pageId": {
                        "type": "string",
                        "description": "The ID of the page to navigate to.",
                        "enum": ["/home", "/editor/scene/", "/editor/list", "/resources/list", "/paint/list", "/catalog/list", "/scheduler/editor", "/events/list", "/stations", "/fasterq/list", "/statistics", "/download", "/shopping/products", "/shopping/list", "/shopping/checkout", "/orders", "/user", "/help"]
                    },
                    "propertyName": {
                        "type": "string",
                        "description": "The property name of the navigation. '/editor/scene/' → 'sceneId', '/help' → 'helpName'",
                        "enum": [ "sceneId", "helpName" ]
                    },
                    "propertyValue": {
                        "type": "string",
                        "description": `
                            if pageId is '/help' get the helpName by search in the result of the function getHelpInfo().' ,
                            if pageId is '/editor/scene/' get sceneId by search in the result of the function getSceneList().`
                    }
                },
                "required": ["pageId"]
            }
        }
    },


    {
        "type": "function",
        "function": {
            "name": "getComponentsDefinition",
            "description": "get information on how to add or update component. get the playerId from this function",
        }
    },

    {
        "type": "function",
        "function": {
            "name": "getSceneList",
            "description": "get the scene list info.",
        }
    },

    {
        "type": "function",
        "function": {
            "name": "createScene",
            "description": "Create a new scene.",
            "parameters": {
                "type": "object",
                "properties": {
                    "sceneName": {
                        "type": "string",
                        "description": "The name of the new scene."
                    },
                    "width": {
                        "type": "integer",
                        "description": "The width of the new scene in pixels. Default is 1920.",
                        "default": 1920
                    },
                    "height": {
                        "type": "integer",
                        "description": "The height of the new scene in pixels. Default is 1080.",
                        "default": 1080
                    }
                },
                "required": ["sceneName", "width", "height"]
            }
        }
    },


    {
        "type": "function",
        "function": {
            "name": "selectScenes",
            "description": "Select scenes id.",
            "parameters": {
                "type": "object",
                "properties": {
                    "sceneIds": {
                        "type": "array",
                        "items": {
                            "type": "string",
                            "description": "Scene ID."
                        },
                        "description": "A list of scenes IDs."
                    }
                },
                "required": ["sceneIds"]
            }
        }
    },

    {
        "type": "function",
        "function": {
            "name": "deleteSelectedScenes",
            "description": "Delete selected scenes.",
        }
    },

    {
        "type": "function",
        "function": {
            "name": "getSceneData",
            "description": "get scene data of the selectedSceneId.",
            "parameters": {
                "type": "object",
                "properties": {
                },
                "required": []
            }
        }
    },


    {
        "type": "function",
        "function": {
            "name": "addComponentToScene",
            "description": "Add a component to a scene.",
            "parameters": {
                "type": "object",
                "properties": {
                    "playerId": {
                        "type": "string",
                        "description": "Get the playerId from getComponentsDefinition."
                    }
                },
                "required": ["playerId"]
            }
        }
    },


    {
        "type": "function",
        "function": {
            "name": "updateComponentProperty",
            "description": "Updates a component property by its id.",
            "parameters": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "description": "The unique id of the component to update."
                    },
                    "playerId": {
                        "type": "string",
                        "description": "Get the playerId from the components table."
                    },
                    "propertyPath": {
                        "type": "string",
                        "description": `The path of the property (e.g., 'Data[0].???[0].Font[0].$').
                                    always use full path in the json.`
                    },
                    "propertyName": {
                        "type": "string",
                        "description": "The property name of the component id to be updated (e.g., 'color', 'width')."
                    },
                    "propertyValue": {
                        "type": "string",
                        "description": "The value of the property to be updated (e.g., '255', 'red', '10')."
                    }
                },
                "required": ["id", "playerId", "propertyPath", "propertyName", "propertyValue"]
            }
        }
    },


    {
        "type": "function",
        "function": {
            "name": "addEffect",
            "description": "add effect to the component property by its id. (e.g., 'background', 'border').",
            "parameters": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "description": "The unique id of the component to add effect."
                    },
                    "effectName": {
                        "type": "string",
                        "description": "The effect name",
                        "enum": ['Background', 'Border'],
                    },
                },
                "required": ["id", "effectName"]
            }
        }
    },

    {
        "type": "function",
        "function": {
            "name": "removeEffect",
            "description": "remove effect from the component with id. (e.g., 'Appearance', 'Background', 'Blur', 'Shadow', 'Border', 'Glow').",
            "parameters": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "description": "The unique id of the component to add effect."
                    },
                    "effectName": {
                        "type": "string",
                        "description": "The effect name",
                        "enum": ['Appearance', 'Background', 'Blur', 'Shadow', 'Border', 'Glow'],
                    },
                },
                "required": ["id", "effectName"]
            }
        }
    },


    {
        "type": "function",
        "function": {
            "name": "selectComponent",
            "description": "Select multiple components in the scene using their unique IDs.",
            "parameters": {
                "type": "object",
                "properties": {
                    "ids": {
                        "type": "array",
                        "items": {
                            "type": "string",
                            "description": "The unique ID of a component to select."
                        },
                        "description": "A list of component IDs to select."
                    }
                },
                "required": ["ids"]
            }
        }
    },



    {
        "type": "function",
        "function": {
            "name": "createImage",
            "description": "Generate an image from a prompt",
            "parameters": {
                "type": "object",
                "properties": {
                    "prompt": {
                        "type": "string",
                        "description": "Description of the image"
                    },
                    "size": {
                        "type": "string",
                        "description": "The size of the image",
                        "enum": ['256x256', '512x512', '1024x1024'],
                        "default": "1024x1024"
                    },
                    "title": {
                        "type": "string",
                        "description": "Assistant will create title base on the image description. max length of 16"
                    }
                },
                "required": ["prompt", "size", "title"]
            }
        }
    },

    {
        "type": "function",
        "function": {
            "name": "modifyImage",
            "description": "Modify selected image id by the user prompt.",
            "parameters": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "description": "The unique id of the component to update."
                    },
                    "resourceId": {
                        "type": "string",
                        "description": "The resource id, it is under the path 'Data[0].Resource[0].$.resource'."
                    },
                    "prompt": {
                        "type": "string",
                        "description": "Prompt to modify the image."
                    },
                    "size": {
                        "type": "string",
                        "description": "The size of the image",
                        "enum": ['256x256', '512x512', '1024x1024'],
                        "default": "1024x1024"
                    },
                    "title": {
                        "type": "string",
                        "description": "Assistant will create title base on the image description. max length of 16"
                    }

                },
                "required": ["id", "resourceId", "prompt", "size", "title"]
            }
        }
    },


    {
        "type": "function",
        "function": {
            "name": "sceneCommand",
            "description": "Call scene commands only when pageId: '/editor/scene/'.",
            "parameters": {
                "type": "object",
                "properties": {
                    "command": {
                        "type": "string",
                        "description": "The scene commands.",
                        "enum": [ "SAVE", "PREVIEW", "REGISTER", "COPY", "PASTE", "UNDO", "REDO", "DELETE" ]
                    }
                },
                "required": ["command"]
            }
        }
    },


    {
        "type": "function",
        "function": {
            "name": "getHelpInfo",
            "description": "get the help info.",
        }
    },


];
